// src/components/PageTransition.jsx
//
// Renders a brief full-screen overlay whenever `viewKey` changes —
// soft black fade + a thin green load-line sweeps left-to-right.
// Bloomberg-Terminal "switching workspaces" feel.
//
// Usage:
//   <PageTransition viewKey={view}>{routedChildren}</PageTransition>
//
import { useEffect, useRef, useState } from 'react';

export default function PageTransition({ viewKey, children }) {
  const prev = useRef(viewKey);
  const [pulse, setPulse] = useState(0); // increments on each transition

  useEffect(() => {
    if (prev.current === viewKey) return;
    prev.current = viewKey;
    // Respect reduced motion — skip the overlay entirely
    if (typeof window !== 'undefined' &&
        window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) return;
    setPulse(p => p + 1);
  }, [viewKey]);

  return (
    <>
      {children}
      {pulse > 0 && (
        <div key={pulse} className="page-transition-overlay" aria-hidden>
          <div className="line" />
        </div>
      )}
    </>
  );
}
